export const getIframeCompanyName = (user) => user?.company?.name;
